import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { isPhoneDevice } from "@/lib/phone";
import { PhoneCall, X } from "lucide-react";

export const PHONE_MODE_KEY = "ohc_phone_mode";

// When this phone's browser is set as "my phone", desktop calls show up here as a one-tap dial card.
export default function PhoneBridge() {
  const [req, setReq] = useState(null);
  const on = isPhoneDevice() && localStorage.getItem(PHONE_MODE_KEY) === "1" && !window.OHCNative;
  useEffect(() => {
    if (!on) return undefined;
    const tick = () => api.get("/mobile/web-next").then(({ data }) => { if (data?.id) setReq(data); }).catch(() => {});
    tick();
    const t = setInterval(tick, 4000);
    return () => clearInterval(t);
  }, [on]);
  if (!req) return null;
  const status = (s) => api.post(`/mobile/call-requests/${req.id}/status`, { status: s }).catch((e) => formatApiError(e));
  const c = req.contact;
  return (
    <div className="fixed inset-x-3 bottom-4 z-[60] bg-[#1E1B4B] text-white rounded-2xl p-4 shadow-2xl" data-testid="phone-bridge-card">
      <button className="absolute top-3 right-3 text-slate-300" onClick={() => { status("cancelled"); setReq(null); }} data-testid="phone-bridge-dismiss"><X className="w-4 h-4" /></button>
      <div className="text-[11px] uppercase tracking-wider text-indigo-300 font-bold">Call from desktop CRM</div>
      <div className="text-lg font-bold mt-1" data-testid="phone-bridge-name">{req.name || c?.name || req.phone}</div>
      <div className="text-sm text-indigo-200">{req.phone}{c ? ` · ${c.type}${c.stage ? ` · ${c.stage}` : ""}` : ""}</div>
      {c && <div className="text-xs text-indigo-200 mt-1 space-y-0.5" data-testid="phone-bridge-info">
        {[c.course, c.city].filter(Boolean).join(" · ") && <div>{[c.course, c.city].filter(Boolean).join(" · ")}</div>}
        {c.email && <div>{c.email}</div>}
        {c.assigned_name && <div>Owner: {c.assigned_name}</div>}
        {c.last_note && <div>Last: {c.last_note}</div>}
      </div>}
      <a href={`tel:${req.phone}`} onClick={() => { status("dialing"); setTimeout(() => { status("completed"); setReq(null); }, 1500); }}
        className="mt-3 flex items-center justify-center gap-2 h-12 rounded-xl bg-emerald-500 font-bold text-base" data-testid="phone-bridge-dial"><PhoneCall className="w-5 h-5" /> Dial now</a>
    </div>
  );
}
